import { Typography } from '@automata/ui';
import { Checkbox, FormControlLabel, List, ListItem } from '@mui/material';
import React from 'react';

import { SelectionPanelBase } from './SelectionPanelBase';
import { selectTaskDependenciesAreVisible } from '../../../features/ui/selectors';
import { setTaskDependenciesAreVisible } from '../../../features/ui/uiSlice';
import { useAppDispatch, useAppSelector } from '../../../hooks';

const ViewSettingsPanel = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const taskDependenciesAreVisible = useAppSelector(
    selectTaskDependenciesAreVisible
  );

  return (
    <SelectionPanelBase title="View settings">
      <Typography variant="subtitle2">Lines</Typography>
      <List sx={{ p: 0 }}>
        <ListItem>
          <FormControlLabel
            control={
              <Checkbox
                checked={taskDependenciesAreVisible}
                onChange={() => {
                  dispatch(
                    setTaskDependenciesAreVisible(!taskDependenciesAreVisible)
                  );
                }}
              />
            }
            label="Task dependencies"
          />
        </ListItem>
      </List>
    </SelectionPanelBase>
  );
};

export default ViewSettingsPanel;
